<template>
	<b-overlay id="overlay-background" class="main-restore-tree" :show="loading" rounded="sm">
		<b-card class="loadContainer">
			<div>
				<div class="filter">
					<span :class="{ 'filtergrid': true }">
						<label for="filtergrid">Filtro: </label>
							<input
							type="text"
							name="filter-kpi"
							class="ml-1 input-pentagro"
							v-model="filterValue"
							@keydown="setFilter"
							/>
					</span>
				</div>
				
				<div class="sheet">
					<div class="grid-historic"></div>
				</div>
	
				<div class="gridBtGroup rowItem" xl="1" lg="4" md="4" sm="4">
					<div class="use-tree">
						<label v-if="version"  class="version-tree">Versão: <strong>{{ version }}</strong> </label>
						<img v-if="version"  src="@/assets/aceitarplanejamento.png" alt="salvar" title="Restaurar versão selecionada" style="height:38px; margin-right: 25px; margin-top: 20px"
							@click="setTree" />
						<b-row class="groupBtn">
							<img src="@/assets/sair.png" alt="Sair" title="Sair." style="margin-right: 12px; margin-top: 20px"
								@click="$bvModal.hide('restoreTree')" />
						</b-row>
					</div>
				</div>
				
				
			</div>
		</b-card>
	</b-overlay>
</template>

<script>
import * as cheetahGrid from "cheetah-grid";
import RestoreIndicatorConfiguration from './tools/RestoreIndicatorConfiguration'
import axios from 'axios';
import { urlMainAPI, defaultSuccess, } from '../../../global';

export default {
	name: "RestoreIndicatorConfiguration",
	props: [ "loadIndicators" ],

	data() {
		return {
			grid: {},
			inficatorConfigurationBackup: [],
			inficatorConfiguration: [],
			loading: false,
			version: 0,
			filterValue: "",
			treeSelected: {},
			loadIndicator: this.loadIndicators,
		}
	},

	methods: {
		async loadInficatorConfigurationBackup(){
			let url = `${urlMainAPI}/getlistindicatorconfigurationbackup`
			await axios.get(url).then(res => {
				if(res.status == 200){
					console.log('res.data :>> ', res.data);
					this.inficatorConfigurationBackup = res.data;
					this.inficatorConfiguration = res.data
				}
			}).catch(console.error)
		},

		setFilter() {
			if(this.filterValue)
				this.inficatorConfiguration = this.inficatorConfigurationBackup.filter(i => 
					i.version.toString().includes(this.filterValue.toUpperCase()) || 
					i.timesTamp.toUpperCase().includes(this.filterValue.toUpperCase()))
			else
				this.inficatorConfiguration = this.inficatorConfigurationBackup;

			this.setGrid()
		},
		
		createGrid(){
			let elementGrid = document.querySelector(".grid-historic")
			elementGrid.innerHTML = "";
			this.grid = new cheetahGrid.ListGrid({
			parentElement: elementGrid,
			allowRangePaste: true,
			defaultColWidth: 100,
			header: RestoreIndicatorConfiguration.header,
			defaultRowHeight: RestoreIndicatorConfiguration.defaultRowHeight,
			headerRowHeight: RestoreIndicatorConfiguration.headerRowHeight
			})

			this.grid.theme = "BASIC";
			this.inficatorConfigurationBackup = this.inficatorConfigurationBackup.length > 1 && this.inficatorConfigurationBackup[0].indicator != "" ? this.inficatorConfigurationBackup : [{}];
			this.grid.records = this.inficatorConfigurationBackup.length > 0 ? this.inficatorConfigurationBackup : [{}];
			this.grid.listen(RestoreIndicatorConfiguration.eventType.SELECTED_CELL, this.onSelectedLine)
		},

		async setGrid(table = this.inficatorConfiguration) {
			this.grid.records = table;
        },
		
		onSelectedLine(line) {
			if (line.selected && line.row > 0) {
				this.version = this.grid.records[line.row - 1].version
				this.treeSelected = JSON.parse(this.grid.records[line.row - 1].tree)
			}
		},

		async setTree(){
			const url = `${urlMainAPI}/saveindicatorconfiguration`
			await axios.post(url, this.treeSelected).then(res => {
					if(res.status == 200){
						defaultSuccess(`Versão ${this.version} restaurada.`)
						this.version = 0;
						this.treeSelected = {};
						this.$bvModal.hide("restoreTree");
					}
				}).catch(console.error)
				this.$emit("loadIndicators", ++this.loadIndicator)
			},
	},

	async mounted() {
		this.loading = true;
		await this.loadInficatorConfigurationBackup();
		this.createGrid();
		this.setGrid();
		this.loading = false;
	},
}
</script>

<style scoped>
main-restore-tree {
	display: grid;
	grid-template-rows: 64vh 10vh;
}

.loadContainer {
    border-radius: 4px;
}

.main-restore-tree>div {
	height: inherit;
}

.grid-historic {
	height: 500px;
}

.gridBtGroup img {
	cursor: pointer;
}

.gridBtGroup,
.use-tree {
	display: flex;
	justify-content: right;
	align-items: center;
}

.card-body {
	margin-bottom: -10px
}

.filter {
	margin-bottom: 20px;
}

.version-tree {
	margin-right: 18px;
	margin-top: 26px;
}

</style>